import React from "react";
import { CartState, CartAction } from "@cart-client/reducers/CartReducer";
import { GiftingCartState, GiftingCartAction } from "@cart-client/reducers/GiftingCartReducer";
import { MROCartAction, MROCartState } from "@cart-client/reducers/MROCartReducer";
import { randomStringIdGenerator } from "@swiggy-private/core-ui";

export interface CartContextValue {
    cartState: CartState | GiftingCartState | MROCartState;
    setCartState: React.Dispatch<CartAction | GiftingCartAction | MROCartAction>;
}

export const CartContext = React.createContext<CartContextValue>({
    cartState: {
        uniqueIdForCart: randomStringIdGenerator(),
        localCart: null,
        reviewedCart: null,
    },
    setCartState: () => void 0,
});

if (__DEV__) {
    CartContext.displayName = "CartContext";
}
